"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VertNavIconButton = exports.VertNavIcon = exports.NavBarToggle = exports.VertNavButtonGroup = exports.VertNavIconWrapper = exports.Wrapper = exports.VertNavButtonsWrapper = exports.Container = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
exports.Container = styled_1.default.div({});
exports.VertNavButtonsWrapper = styled_1.default.div(props => ({
    position: 'relative',
    height: 'auto',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px 0 0',
    zIndex: props.theme.layers.ui,
}));
exports.Wrapper = styled_1.default.div(({ theme }) => ({
    background: theme.colors.blue80,
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.2s',
}), ({ expanded }) => ({
    minWidth: expanded ? '212px' : '56px',
    width: expanded ? '212px' : '56px',
}));
exports.VertNavIconWrapper = styled_1.default.div({
    display: 'flex',
    minWidth: '37px',
    height: '37px',
    justifyContent: 'center',
    alignItems: 'center',
});
exports.VertNavButtonGroup = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
});
exports.NavBarToggle = styled_1.default.div(({ expanded }) => ({
    position: 'absolute',
    transition: 'all 200ms',
    bottom: '12px',
    left: expanded ? '212px' : '56px',
    transform: 'translateX(-50%)',
    zIndex: -1,
}));
exports.VertNavIcon = styled_1.default.div(({ expanded, theme, onClick }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        marginTop: theme.space[1],
        fontSize: '1rem',
        height: '38px',
        marginBottom: '20px',
        whiteSpace: 'nowrap',
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: expanded ? '24px' : '10px',
        transition: 'padding 200ms ease',
        cursor: onClick ? 'pointer' : 'auto',
        '>div': {
            minWidth: 'auto',
        },
    };
});
exports.VertNavIconButton = styled_1.default.button(({ theme, nested, transparentHover, active }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        transition: '.2s linear all',
        cursor: 'pointer',
        border: 0,
        padding: 0,
        fontSize: '1rem',
        height: '56px',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        width: '100%',
        justifyContent: 'flex-start',
        paddingLeft: theme.space[3],
        background: active
            ? theme.colors.blue50
            : nested
                ? theme.colors.darkBluePearlSemiTransparent
                : 'transparent',
        ':hover': {
            background: transparentHover ? 'transparent' : theme.colors.blue50,
        },
    };
}, ({ expanded, theme, nested }) => {
    if (expanded) {
        return {
            paddingLeft: nested ? theme.space[4] : theme.space[3],
        };
    }
});
//# sourceMappingURL=vertical_icon_bar.styles.js.map